export default {"src":"/_next/static/media/BLNK.cd421454.svg","height":18,"width":18};